import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { PostcodesService } from '../services/postcodes.service';
import { Postcode } from '../../models/postcode';

@Injectable()
export class OpenPostcodesResolver implements Resolve<Postcode[]>
{
	private postcodesService: PostcodesService;

	constructor(postcodesService: PostcodesService)
	{
		this.postcodesService = postcodesService;
	}

	resolve(): Promise<Postcode[]>
	{
		return this.postcodesService.getOpenPostcodes();
	}
}



// WEBPACK FOOTER //
// ./src/app/postcodes/resolvers/open-postcodes.resolver.ts